import Header from "@components/Header/Header"
import KYCLevelBanner from "@components/KYCLevelBanner/KYCLevelBanner"
import KYCLevelCard from "@components/KYCLevelCard/KYCLevelCard"
import PrimaryButton from "@components/PrimaryButton/PrimaryButton"
import { useNavigate } from "react-router"
import { useTranslation } from "react-i18next"
import {
    Container,
    ContentContainer,
    ContentWrapper,
    DescriptionText,
    LevelCardsContainer,
    BottomButtonContainer
} from "./AccountUpgrade.styles"
import useKYCBenefit from "@hooks/useKYCBenefit"
import LoadingModal from "@components/LoadingModal/LoadingModal"
import useKYCDetail from "@hooks/useKYCDetail"
import { redirectToTelegramSupport } from '../../lib/utils'
import { INCREASE_LIMIT_SUPPORT_MESSAGE } from '@constants/kyc'

const AccountUpgrade = () => {
    const navigate = useNavigate()
    const { isLoading: isKYCDetailLoading, levelNumber } = useKYCDetail()
    const { data: kycLevelBenefits, isLoading: isKYCBenefitsLoading } = useKYCBenefit()
    const { t } = useTranslation()
    return (
        <Container>
            <Header title={t('page.account.upgrade.header')} showBackButton onBackClick={() => navigate('/account')} />
            <LoadingModal visible={isKYCBenefitsLoading || isKYCDetailLoading} />
            <ContentContainer>
                <ContentWrapper>
                    <KYCLevelBanner level={levelNumber} />
                    <DescriptionText>
                        {t('page.account.upgrade.description')}
                    </DescriptionText>
                    <LevelCardsContainer>
                        {kycLevelBenefits.map((level, index) => (
                            index !== 0 && <KYCLevelCard
                                key={index}
                                level={index}
                                boldHeader={false}
                                benefits={level.benefits}
                                disabled={!level.isActive}
                            />
                        ))}
                    </LevelCardsContainer>
                </ContentWrapper>
            </ContentContainer>
            <BottomButtonContainer>
                <PrimaryButton
                    disabled={!kycLevelBenefits?.[levelNumber + 1]?.isActive}
                    onClick={() => redirectToTelegramSupport('JagadCS_bot', INCREASE_LIMIT_SUPPORT_MESSAGE)}
                >{t('page.account.upgrade.upgradeButton')}</PrimaryButton>
            </BottomButtonContainer>
        </Container>
    )
}

export default AccountUpgrade